import { BasicAttributesSection } from './sections/BasicAttributesSection'
import { TransferListSection } from './sections/TransferListSection'
import { TriggersSection } from './sections/TriggersSection'
import { CommonFormProps } from './types'

export const CommonForm = ({ variant }: CommonFormProps): JSX.Element => (
  <>
    <BasicAttributesSection variant={variant} />
    <TriggersSection variant={variant} />
    <TransferListSection variant={variant} />
  </>
)
